<template>
  <v-row>
    <v-tabs align-with-title
            background-color="kbWhite"
            show-arrows
            v-model="tab">
      <v-tabs-slider color="kbPurple"/>

      <v-tab v-for="item in tabsItems"
             :key="item"
             style="text-transform: capitalize">
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-row class="px-2">
      <v-col cols="12">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card color="kbWhite" flat>
              <v-card-text>
                <v-row>
                  <v-col class="text-h6"
                         cols="12">
                    Registered Emails
                  </v-col>

                  <v-col cols="12" v-if="loading">
                    <v-progress-circular color="kbPurple"
                                         indeterminate>
                    </v-progress-circular>
                  </v-col>

                  <v-col cols="12" v-else-if="emails.length === 0">
                    <v-icon class="mr-2"
                            color="kbRed">
                      mdi-alert
                    </v-icon>
                    You don't have registered emails
                  </v-col>

                  <v-col cols="12" v-else>
                    <v-chip class="mr-2"
                            color="kbPurple"
                            dark
                            :key="email._id"
                            v-for="email in emails">
                      {{email.email}}
                    </v-chip>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="kbPurple"
                           dark
                           :href="`https://goauth.cloudtask.com/gmail/auth?urlReturn=https://gap.cloudtask.com/settings/emails&token=${$store.getters.token}`">
                      {{ $t('general.connectAccount') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card color="kbWhite" flat>
              <v-card-text>
                <v-form lazy-validation
                        ref="updateLimitsForm"
                        v-model="validForm">
                  <v-row>
                    <v-col cols="12">
                      <v-select :items="emails"
                                item-text="email"
                                return-object
                                :rules="[rules.required]"
                                label="Select an email"
                                v-model="selectedEmail">
                      </v-select>
                    </v-col>

                    <v-col cols="12" sm="6" class="text-caption">
                      Maximun emails that can be sent by a user per day
                      <v-text-field class="mt-3"
                                    color="kbPurple"
                                    outlined
                                    :rules="[rules.required]"
                                    type="number"
                                    v-model="selectedEmail.limitPer24Hours">
                      </v-text-field>
                      Limit on the # of emails to send per day through GAP. The recommended limit is between 100 or 400, depending on the type of Google Apps acount you have. Read more about Gmail's limits here. Note in realty this limit may be much lower. The upper limit of emails you can send per day is equal to 1000 x the number of hours per day in your sequence sending windows.
                    </v-col>

                    <v-col cols="12" sm="6" class="text-caption">
                      Maximun emails that can be sent by a user per hour
                      <v-text-field class="mt-3"
                                    color="kbPurple"
                                    outlined
                                    :rules="[rules.required]"
                                    type="number"
                                    v-model="selectedEmail.limitPerHour">
                      </v-text-field>
                      Limit on the # of emails to send per hour through GAP. This number cannot be greater than 600, as Gmail limits sending to 10 per minute. The recommended limit is not higher than 100.
                    </v-col>

                    <v-col cols="12">
                      <v-btn @click="updateLimitsForEmail"
                             color="kbPurple"
                             dark
                             :loading="loadingUpdates">
                        Update Limits
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import authService from '@/services/authService'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'

export default {
  async created () {
    try {
      this.loading = true
      this.emails = await authService.getRegisteredEmails()

      if (this.emails.length > 0) {
        this.selectedEmail = this.emails[0]
      }
      this.loading = false
    } catch (e) {
      notifications.error(e.message)
      this.loading = false
    }
  },
  data: () => ({
    emails: [],
    loading: false,
    loadingUpdates: false,
    rules,
    selectedEmail: {},
    tab: '',
    tabsItems: ['Mailboxes', 'Limits'],
    validForm: true
  }),
  methods: {
    async updateLimitsForEmail () {
      try {
        if (!this.$refs.updateLimitsForm.validate()) return

        this.loadingUpdates = true
        const data = {
          email: this.selectedEmail.email,
          limitPer24Hours: this.selectedEmail.limitPer24Hours,
          limitPerHour: this.selectedEmail.limitPerHour
        }
        await authService.updateLimitsForEmail(data)
        notifications.success('Limits was updated')
        this.loadingUpdates = false
      } catch (e) {
        notifications.error(e.message)
        this.loadingUpdates = false
      }
    }
  }
}
</script>
